import React, { useEffect } from "react";
import "../Pages/CleeQ.css";
import "../Pages/Responsive.css";
import { makeStyles } from "@material-ui/core/styles";
import Aos from "aos";
import "aos/dist/aos.css";
import ContactUs from "./ContactUs";
// import Events from "../Events";
import News from "./News";
import "../Components/NavBar/NavBar.css";
import NavBar from "../Components/NavBar/NavBar";
import SocialHeadings from "../Components/SocialHeadings";

// const NavBar = () => {
//   return (
//     <div className="container NavBarContainer p-0">
//       <div>
//         <SoleraLogo />
//       </div>
//       <div>
//       <NavBarList/>
//       </div>

//       <div className="SignUpAndLoginContianer22">
//         <SignUpAndLogin />
//       </div>
//     </div>
//   );
// };

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
}));

function Gallery() {
  useEffect(() => {
    Aos.init({ duration: 1000 });
    window.scrollTo(0, 0); // This will scroll the page to the top when the component mounts
  }, []);

  const classes = useStyles();

  return (
    <div>
      <header className="SoleraSticky">
      <div className="SocialHeadings-Display">
          <SocialHeadings />
        </div>
        <NavBar />
      </header>

      {/* <div id="Home">
        <OurLanding />
      </div> */}

     
      {/* <div id="News">
        <News />
      </div>
      <div id="Projects">
        <Projects />
      </div> */}

      {/* <div id="Gallery">
        <Gallery />
      </div> */}
      









   <div>
      <div className="SoleraBody214">
        <div className="container EventOthers landing-page-container">
          <div>
            <div>
              <div className="LandingHedings1" data-aos="zoom-in-up">
                Photo Gallery
              </div>
              <div className="NO-Events">Pictures from past events</div>
            </div>
            <br /> <br />
            <div className="container-fluid p-0">
              <div className="row g-2">
                <div className="col-lg-2">
                  <div className="EventPics">
                    {" "}
                    <div>
                      <img
                        src="/assets/solera/12345.png"
                        alt=""
                        className="Photogallary "
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className=" EventPics">
                    {" "}
                    <img
                      src="/assets/solera/999.png"
                      alt=""
                      className="Photogallary "
                    />
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className=" EventPics">
                    {" "}
                    <img
                      src="/assets/solera/2047.png"
                      alt=""
                      className="Photogallary "
                    />
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className=" EventPics">
                    {" "}
                    <img
                      src="/assets/solera/333.png"
                      alt=""
                      className="Photogallary "
                    />
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className=" EventPics">
                    {" "}
                    <img
                      src="/assets/solera/414.png"
                      alt=""
                      className="Photogallary "
                    />
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className=" EventPics">
                    {" "}
                    <img
                      src="/assets/solera/2045.png"
                      alt=""
                      className="Photogallary "
                    />
                  </div>
                </div>
              </div>
            </div>{" "}
            <br />
            <div className="container-fluid p-0">
              <div className="row g-2">
                <div className="col-lg-2">
                  <div className="EventPics">
                    {" "}
                    <div>
                      <img
                        src="/assets/solera/2041.png"
                        alt=""
                        className="Photogallary "
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className=" EventPics">
                    {" "}
                    <img
                      src="/assets/solera/443355.png"
                      alt=""
                      className="Photogallary "
                    />
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className=" EventPics">
                    {" "}
                    <img
                      src="/assets/solera/2019.png"
                      alt=""
                      className="Photogallary "
                    />
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className=" EventPics">
                    {" "}
                    <img
                      src="/assets/solera/2046.png"
                      alt=""
                      className="Photogallary "
                    />
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className=" EventPics">
                    {" "}
                    <img
                      src="/assets/solera/446655.png"
                      alt=""
                      className="Photogallary "
                    />
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className=" EventPics">
                    {" "}
                    <img
                      src="/assets/solera/123432.png"
                      alt=""
                      className="Photogallary "
                    />
                  </div>
                </div>
              </div>
            </div>
            <br />
            <div className="container-fluid p-0">
              <div className="row g-2">
                <div className="col-lg-2">
                  <div className="EventPics">
                    {" "}
                    <div>
                      <img
                        src="/assets/solera/2020.png"
                        alt=""
                        className="Photogallary "
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className=" EventPics">
                    {" "}
                    <img
                      src="/assets/solera/2021.png"
                      alt=""
                      className="Photogallary "
                    />
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className=" EventPics">
                    {" "}
                    <img
                      src="/assets/solera/120.png"
                      alt=""
                      className="Photogallary "
                    />
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className=" EventPics">
                    {" "}
                    <img
                      src="/assets/solera/2024.png"
                      alt=""
                      className="Photogallary "
                    />
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className=" EventPics">
                    {" "}
                    <img
                      src="/assets/solera/2043.png"
                      alt=""
                      className="Photogallary "
                    />
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className=" EventPics">
                    {" "}
                    <img
                      src="/assets/solera/2027.png"
                      alt=""
                      className="Photogallary "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
        </div>
      </div>
    </div>

      <div id="Photo Gallery">
        <ContactUs />
      </div>
    </div>
  );
}

export default Gallery;
